import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './canvasComponent.scss';
import CanvasContainerComponent from './canvasContainerComponent';
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { getCanvasBlockSize, getIframeSizes, getLongSize, loadInfoBlock } from '../../../utils/canvasUtils';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { storeStructure } from '../../../store/reducers';
import { createCanvasContentInfo } from '../../../store/actions/canvasContentInfoActions';
import sportRoomIcon from '../../atoms/customIcons/sportRoomIcon.svg'; 
import calendarIcon from '../../atoms/customIcons/calendarIcon.svg';
import staticImageIcon from '../../atoms/customIcons/staticImageIcon.svg';
import highlightedContentIcon from '../../atoms/customIcons/highlightedContentIcon.svg';
import externalVideoIcon from '../../atoms/customIcons/externalVideoIcon.svg';
import carouselIcon from '../../atoms/customIcons/carouselIcon.svg';
import spacesCarouselIcon from '../../atoms/customIcons/spacesCarouselIcon.svg';
import contentCategoryIcon from '../../atoms/customIcons/contentCategoryIcon.svg';
import contentApp2AppTravelIcon from '../../atoms/customIcons/contentApp2AppTravelIcon.svg';
import interactableGraphicsIcon from '../../atoms/customIcons/interactableGraphicsIcon.svg';
import closeDrawerIcon from '../../atoms/customIcons/closeDrawer.svg';
import Accordion2 from '../../molecules/accordion2/accordion2';
import AlertsIcon from '../../atoms/customIcons/alertIcon.svg';
import { epochToDate } from '../../../utils/dateUtils';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import Icon, { IconSize, IconType } from '../../atoms/icon/icon';

/**
 * Canvas Containers 
 */
const CanvasContainers = (props) => {
  const {
    mode,
    canvasMode,
    containers,
    infoContent,
    dateSelected,
    blockSelected,
    updateCanvas,
    onNewContainer,
    onDeleteContainer,
    onUpdateContainer,
    onBlockSelected,
    onUpdateInfoContent,
  } = props;
 
  const [isOpen, setIsOpen] = useState(false)
  const [items,setItems] =useState([]);
  const [drawerInfo,setDrawerInfo] =useState(null);
  const [drawerInfoType,setDrawerInfoType] =useState(null);
  const [containersDraw,setContainersDraw] =useState(null);
  const [showCopyPopup, setShowCopyPopup] = useState(false);
  const CanvasInfoContent = useSelector((state) => state[storeStructure.CanvasContentInfo], shallowEqual);
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const dispatch = useDispatch();

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  
  const grid = "0 8px";
  
  useEffect(() => {
    setContainersDraw(containers);
  }, [dateSelected,containers]);

  useEffect(() => {
    setContainersDraw(null);
   setTimeout(()=>{
      setContainersDraw(containers);
    },60);
    
  }, [updateCanvas]);

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : 'inherit',
    display: 'flex',
    // padding: grid,
    // overflowX: 'auto',
    // overflowY:'hidden'
  });

  const onDragEnd=(result)=> {
    if (!result.destination) {
        return;
    }
    const itemsOrdered = reorder(
      containers,
      result.source.index,
      result.destination.index
    );
    setItems(itemsOrdered);
    onUpdateContainer(itemsOrdered,canvasMode);
  }

  const handleInfoClicked=(value)=>{
    let found = CanvasInfoContent && CanvasInfoContent.find((item)=>item.UID==value.contents.UID);
    if(found){
      setDrawerInfoType(value.contents.type);
      setDrawerInfo({"content":value,"info":found.info});
      handlerOpenDrawer();
    }else{
      loadInfoBlock(value,session,null,(info)=>{
        let newElement=JSON.parse(JSON.stringify(value.contents));
        newElement.info=info;
        dispatch(createCanvasContentInfo([newElement]));
        setDrawerInfoType(value.contents.type);
        setDrawerInfo({"content":value,"info":info});
        handlerOpenDrawer();
      });
    }
  }

  const handlerCloseDrawer=(e,prevent=false)=>{
    if(prevent)
      e.preventDefault();  

    setIsOpen(false);
  }

  const handlerOpenDrawer=()=>{
    setIsOpen(true);
  }

  const handleOnNewContainer=(index,canvasMode)=>{
    // console.log("neekeke",index,canvasMode);
    onNewContainer(index,canvasMode);
  }

  const handleOnDeleteContainer=(index,canvasMode)=>{
    onDeleteContainer(index,canvasMode);
  }

  const handleOnUpdateContainer=(index,container,canvasMode)=>{
    let newContainers=[...containers];
    newContainers=newContainers[index]=container;
    onUpdateContainer(containers,canvasMode);
  }

  const DrawContentTitle=(props)=>{
    const {title,subTitle,type} =props;
    let icon;
    switch (type){
      case "carousel":
        icon=carouselIcon;
      break;
      case "spacesCarousel":
        icon=spacesCarouselIcon;
      break;
      case "highlighted":
        icon=highlightedContentIcon;
      break;
      case "interactable":
        icon=interactableGraphicsIcon;
      break;
      case "static":
        icon=staticImageIcon;
      break;

      case "sportroom":
        icon=sportRoomIcon;
        break;
      case "calendar":
        icon=calendarIcon;
        break;
      case "category":
        icon=contentCategoryIcon;
        break;
      case "App2AppTravel":
        icon=contentApp2AppTravelIcon;
        break;
      default:
      
        icon=type;
    }
    return <div className="drawer-header-position">
            <div className="drawer-icon"><img className="drawer-icon-image" src={icon}/></div>
            <div className="drawer-title-block"> 
              <div className="drawer-title">{title}</div>
              <div className="drawer-subtitle">{subTitle}</div>
            </div>
            <div className="drawer-button"><a href="#" className="drawer-button-size" onClick={(e)=>{handlerCloseDrawer(e,true)}}><img src={closeDrawerIcon}/></a></div>
        </div>
  }

  const DrawContentEpochs=(props)=>{
    const {data} =props;
    if(data){
      let startD = epochToDate(data.content.startEpoch);//new Date( new Date(data.content.startEpoch).toUTCString() ).toLocaleString()
      let endD = epochToDate(data.content.endEpoch);//new Date( new Date(data.content.endEpoch).toUTCString() ).toLocaleString()
      return (
        <div className="drawer-100">
            <div className="drawer-block drawer-item ">
              <div className="drawer-accordion-body-block" id="block_timeline">
                  <div className="drawer-accordion-body-block-title">Timeline</div>
                  <div><span className="drawer-accordion-body-block-subtitle">Schedule Start: </span>
                  <span className="drawer-accordion-body-block-value">{startD}</span></div>
                  <div><span className="drawer-accordion-body-block-subtitle">Schedule End: </span>
                  <span className="drawer-accordion-body-block-value">{endD?endD:"NO DATE FOUND"}</span></div>
                  <div><span className="drawer-accordion-body-block-subtitle">Block size: </span>
                  <span className="drawer-accordion-body-block-value"> {getCanvasBlockSize(data.content.w,data.content.h)}</span></div>
              </div>
             </div>  
        </div>)
    }
    else
      return <div></div>
  }
  
  const getCategoryNameFromList=(list)=>{
    let cats="";
    let index=0;
    if(list.length>0){
      list.map((cat)=>{
        if(index==0)
          cats+=cat.name;
        else
          cats+=", " +cat.name;
        index+=1;
        return cats;
        
      });
    }
    if(cats=="")
      return "(no category)";
    else
      return cats;
  }

  const getLiveStatus=(data)=>{
    if(data.isLive==true){
      let now=new Date().getTime();
      if(data.activationEpoch<now && (data.expirationEpoch==0|| data.expirationEpoch>now)){
        if(data.startEpoch>0 && data.startEpoch>now){
          if(data.isLiveOngoing==1 && data.isLiveEnded==0){
            return "visible (LIVE BEFORE STARTING TIME)";
          }else if(data.isLiveEnded==1){
              return "visible (LIVE FINISHED)";
            
          }else
            return "visible (ABOUT TO START)";
        }else if(data.startEpoch<now){
          return "visible (LIVE)";
        }else{
          return "visible (STOPPED)";
        }
      }else{
        return "unknown";
      }
    }else 
      return "error";
  }
  const getEmbedUrlComposeExperience=(url)=>{
    return "https://embed-web-sdk.ybvr.com/?content="+url;
  }

  const HtmlBodyCalendar=(props)=>{
    const {data,size} =props;
    const [myData,setMyData] =useState(null);
    useEffect(()=>{
      setMyData(data);
    },[data]);
    return <div>
    {myData && <div className="drawer-block drawer-accordion-body-block" id="block_calendar_content">
      <div className="drawer-accordion-body-block-title">Content</div>
      <div><span className="drawer-accordion-body-block-subtitle">Max number of elements: </span>
      <span>{myData.info.maxNumElements}</span></div>
    </div>}
    {myData && <DrawerPreview url={myData.info.image} />}
  </div>;
  }

  const HtmlBodySportRoom=(props)=>{
    const {data,size} =props;
    const [myData,setMyData] =useState(null);

    useEffect(()=>{
      setMyData(data);
    },[data]);
    return <div>
      {myData && <div>
        <div className="drawer-block drawer-accordion-body-block" id="block_roomContent">
          <div className="drawer-accordion-body-block-title">Content</div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Name: </span>
               <span className="drawer-accordion-body-block-value">{myData.name}</span>{(myData.contentLink ||  myData?.link ) && (
              <a target="_blank" href={myData?.contentLink ?? myData?.link } rel="noreferrer"> (sportroom link)</a>
               )}
          </div>
          <div><span className="drawer-accordion-body-block-subtitle">Autenticated Room: </span>
            <span className="drawer-accordion-body-block-value">NO</span>
          </div>
        </div>
        <div className="drawer-block drawer-accordion-body-block" id="block_poster_info">
          <div className="drawer-accordion-body-block-title">Poster</div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">{size} Grid Poster: </span>
            <span className="drawer-accordion-body-block-value">{(myData.image?<img style={{width:'150px'}}  src={myData.image}/>:"NO IMAGE FOR THIS SIZE")}</span>
          </div>
        </div>
      </div>}
    </div>;
  }

  const HtmlBodyHighlighted=(props)=>{
    const {data,size} =props;
    const [myData,setMyData] =useState(null);
    const [myActivationTime,setMyActivationTime]=useState(null);
    const [myStartingTime,setMyStartingTime]=useState(null);
    const [myExpirationTime,setMyExpirationTime]=useState(null);
    const [liveStatus,setLiveStatus] =useState(null);

    useEffect(()=>{
      setMyActivationTime(epochToDate(data.activationEpoch));
      setMyStartingTime(epochToDate(data.startEpoch));
      setMyExpirationTime(epochToDate(data.expirationEpoch));
      setLiveStatus(getLiveStatus(data));
      setMyData(data);
    },[data]);
    return (<div>
      {myData && <div>
        <div className="drawer-block drawer-accordion-body-block" id="block_highlightedContent">
          <div className="drawer-accordion-body-block-title">Content</div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Name: </span>
            <span className="drawer-accordion-body-block-value">{myData.name}</span>{myData.contentLink && (
              <a target="_blank" href={myData.contentLink} rel="noreferrer">(content link)</a>
              )}
          </div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Category: </span>
            <span className="drawer-accordion-body-block-value">{getCategoryNameFromList(data.appCategories)}</span>
          </div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Media URL: </span>
            <span className="drawer-accordion-body-block-value">{myData.composeExperience}</span><a target="_blank" href={getEmbedUrlComposeExperience(myData.composeExperience)}> (preview)</a>
          </div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Duration: </span>
            <span className="drawer-accordion-body-block-value">{myData.duration}</span>
          </div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Visibility: </span>
            <span className={"drawer-accordion-body-block-value"+(myData.visibility=="hidden"?" field-red":"")}>{myData.visibility}</span>
          </div>
        </div>
        <div className="drawer-block drawer-accordion-body-block" id="block_poster_info">
          <div className="drawer-accordion-body-block-title">Poster</div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">{size} Grid Poster: </span>
            <span className="drawer-accordion-body-block-value">{myData.image?<img style={{width:'150px'}} src={myData.image}/>:<><div className="d-inline-block bg-red m-1"><img src={AlertsIcon}/></div><div className="d-inline-block"> No image for this size</div></>}</span>
          </div>
        </div>
        <div className="drawer-block drawer-accordion-body-block" id="block_otherInfo">
          <div className="drawer-accordion-body-block-title">Other info</div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Is live: </span>
            <span className="drawer-accordion-body-block-value">{myData.isLive==true?"Yes":"No"}</span>
          </div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Activation Time: </span>
            <span className="drawer-accordion-body-block-value">{myActivationTime?myActivationTime:"NO DATE FOUND"}</span>
          </div>
          <div>
            <span className="drawer-accordion-body-block-subtitle">Expiration Time: </span>
            <span className="drawer-accordion-body-block-value">{myExpirationTime?myExpirationTime:"NO DATE FOUND"}</span>
          </div>  
          {data.isLive==true && <>
            <div>
              <span className="drawer-accordion-body-block-subtitle">Starting Time: </span>
              <span className="drawer-accordion-body-block-value">{myStartingTime?myStartingTime:"NO DATE FOUND"}</span>
            </div>  
            <div>
              <span className="drawer-accordion-body-block-subtitle">Is Live Ongoing: </span>
              <span className="drawer-accordion-body-block-value">{(myData.isLiveOngoing?"Yes":"No")}</span>
            </div>          
            <div>
              <span className="drawer-accordion-body-block-subtitle">Is Live Ended: </span>
              <span className="drawer-accordion-body-block-value">{(myData.isLiveEnded?"Yes":"No")}</span>
            </div>                  
            <div>
              <span className="drawer-accordion-body-block-subtitle">Status: </span>
              <span className="drawer-accordion-body-block-value">{liveStatus}</span>
            </div>
            <div>
              <span className="drawer-accordion-body-block-subtitle">Content size: </span>
              <span className="drawer-accordion-body-block-value">{size}</span>
            </div></>}
          </div>
          <div className="drawer-block drawer-accordion-body-block" id="block_virtualTicket">
            <div className="drawer-accordion-body-block-title">Virtual Ticket</div>
            <div>
              <span className="drawer-accordion-body-block-subtitle">Purchable content: </span>
              <span className="drawer-accordion-body-block-value">{myData.appPackages && myData.appPackages.length>0?"Yes":"No"}</span>
            </div>
            {myData.appPackages && myData.appPackages.length>0 && <div>
              <span className="drawer-accordion-body-block-subtitle">Virtual Ticket Provider: </span>
              <span className="drawer-accordion-body-block-value">IN-app purchase</span>
            </div>}
          </div>
        </div>}
      </div>);
  }

  const HtmlBodyInteractableGraphics=(props)=>{
    const {data,size}=props;
    const [myData,setMyData] =useState(null);
    useEffect(()=>{
      setMyData(data);
    },[data]);
    return <div>
      {myData && <div className="drawer-block drawer-accordion-body-block" id="block_interactableGraphicsContent">
        <div className="drawer-accordion-body-block-title">Content</div>
        <div>
          <span className="drawer-accordion-body-block-subtitle">URL: </span>
          <span className="drawer-accordion-body-block-value">{(myData.image?<a target="_blank" href={myData.image}>{myData.image}</a>:"NO URL SELECTED")}</span>
        </div>
      </div>}
    </div>;
  }
  const DrawerPreview=(props)=>{
    const {url,size}=props;
    const [myUrl,setMyUrl] =useState(null);
    const [width,setWidth] =useState(450);
    const [height,setHeight] =useState(450);
    
    useEffect(()=>{
      if(url){
        let s=getIframeSizes(size);
        setWidth(s[0]);
        setHeight(s[1]);
        console.log(s);
        setMyUrl(url);
      }
    },[url]);
    return <div>
      {myUrl && <div className="drawer-block drawer-accordion-body-block" id="block_preview">
        <div className="drawer-accordion-body-block-title">Preview</div>
        <div>
          <iframe style={{overflow:"hidden"}} scrolling="no" src={url} width="450" height="450"/>
        </div>
      </div>}
    </div>;
  }
  const HtmlBodyApp2AppTravel=(props)=>{
    const {data,size} =props;
    const [myData,setMyData] =useState(null);
    useEffect(()=>{
      setMyData(data);
    },[data]);
    return <div>
      {myData && <div className="drawer-block drawer-accordion-body-block" id="block_poster_info">
      <div className="drawer-accordion-body-block-title">App2App Travel information</div>
      <div>
        <div className="drawer-accordion-body-block-subtitle">Size: {size} </div>
        <div className="drawer-accordion-body-block-subtitle">Application Id: {myData.applicationId?<span>{myData.applicationId}</span>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Destination Api Name: {myData.destinationApiName?<span>{myData.destinationApiName}</span>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Lobby Id: {myData.lobbyId?<span>{myData.lobbyId}</span>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Match Id: {myData.matchId?<span>{myData.matchId}</span>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Deep Link Message: {myData.deepLinkMessage?<span>{myData.deepLinkMessage}</span>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Default Image: {myData.defaultUrl?<img src={myData.defaultUrl}/>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Secondary Image: {myData.secondaryUrl?<img src={myData.secondaryUrl}/>:"-"}</div>
        <div className="drawer-accordion-body-block-subtitle">Override Deeplink: {myData.overrideDeeplink==true?<span>true</span>:"false"}</div>
      </div>
    </div>}
  </div>;
  }
  const HtmlBodyStaticImage=(props)=>{
    const {data,size} =props;
    const [myData,setMyData] =useState(null);
    const handleCopyLink = async () => {
      if (!myData?.image) return;
        try {
          await navigator.clipboard.writeText(myData.image);
          setShowCopyPopup(true);

          setTimeout(() => {
            setShowCopyPopup(false);
          }, 2000);
        } catch (error) {
          console.error("Error al copiar el enlace", error);
        }
    };
    useEffect(()=>{
      setMyData(data);
    },[data]);
    return <div>
        {myData && <div className="drawer-block drawer-accordion-body-block" id="block_poster_info">
          <div className="drawer-accordion-body-block-title">Poster</div>
          <div>
            <div className="drawer-accordion-body-block-subtitle">Size: {size} </div>
            <div className="drawer-accordion-body-block-subtitle">Url: {myData.image?<a href={myData.image} target="_blank">{myData.image}</a>:"NO IMAGE FOR THIS SIZE"}</div>
            <Button key={`button-copy`} className="mr-2" type={ButtonType.BUTTON} icon={IconType.COPY} onClick={handleCopyLink}/>
            {showCopyPopup && (
              <div className="mt-2 d-flex align-items-center text-success">
              <Icon icon={IconType.CHECK} iconSize={IconSize.SMALL} className="mr-1"/> Enlace copiado </div>
            )}
          </div>
        </div>}
        {myData && <DrawerPreview url={myData.image} size={size}/>}
      </div>;
  }
  const HtmlBodyBackgroundImage=(props)=>{
    const {data,size} =props;
    const [myData,setMyData] =useState(null);
     const handleCopyLink = async () => {
      if (!myData?.image) return;
        try {
          await navigator.clipboard.writeText(myData.image);
          setShowCopyPopup(true);

          setTimeout(() => {
            setShowCopyPopup(false);
          }, 2000);
        } catch (error) {
          console.error("Error al copiar el enlace", error);
        }
    };
    useEffect(()=>{
      setMyData(data);
    },[data]);
    console.group('data',data)
    return <div>
        {myData && <div className="drawer-100 drawer-accordion-body-block" id="block_background_info">
          <div className="drawer-accordion-body-block-title">Background Image</div>
          
          <div>
            <div className="drawer-accordion-body-block-subtitle">Size: {size} </div>
            <div className="drawer-accordion-body-block-subtitle">Url: {myData.backgroundImage.url?<a href={myData.backgroundImage.url} target="_blank">{myData.backgroundImage.url}</a>:"NO IMAGE FOR THIS SIZE"}</div>
            <Button key={`button-copy`} className="mr-2" type={ButtonType.BUTTON} icon={IconType.COPY} onClick={handleCopyLink}/>
            {showCopyPopup && (
              <div className="mt-2 d-flex align-items-center text-success">
              <Icon icon={IconType.CHECK} iconSize={IconSize.SMALL} className="mr-1"/> Enlace copiado </div>
            )}
          </div>
        </div>}
        {myData && <DrawerPreview url={myData.image} size={size}/>}
      </div>;
  }

  const DrawContentInteractableGraphicsDetails=(props)=>{
    const {data} =props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
    }
    return (<div className="drawer-100 drawer-overflow height-147">
      <div className="drawer-carousel">
        <DrawContentEpochs data={data} />
        <HtmlBodyInteractableGraphics data={(data && data.info?data.info:null)} size={size} />
        <DrawerPreview url={data && data.info?data.info.image:null} size={size}/>
      </div>
    </div>);
  }
  const DrawContentCalendarDetails=(props)=>{
    const {data} =props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
    }
    return (<div className="drawer-100 drawer-overflow height-147">
    <div className="drawer-carousel">
        <DrawContentEpochs data={data} />
        <HtmlBodyCalendar data={data?data:null} size={size} />
      </div>
    </div>);
  }

  const DrawContentStaticImageDetails=(props)=>{
    const {data} =props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
    }
    return (<div className="drawer-100 drawer-overflow height-147">
      <div className="drawer-carousel">
        <DrawContentEpochs data={data} />
        {data && <HtmlBodyStaticImage data={data.info} size={size} />}

      </div>
    </div>);
  }
  const DrawContentBackgroundImageDetails=(props)=>{
    const {data} =props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
    }
    return (<div className="drawer-100">
      <div className="drawer-carousel">
        {data && <HtmlBodyBackgroundImage data={data.info} size={size} />}
      </div>
    </div>);
  }
  const DrawContentApp2AppTravelDetails=(props)=>{
    const {data} = props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
    }
    return (<div className="drawer-100 drawer-overflow height-147">
      <div className="drawer-app2app">
        <DrawContentEpochs data={data} />
        {data && <HtmlBodyApp2AppTravel data={data.info} size={size} />}

      </div>
    </div>);
    
  }

  const DrawContentCategoryDetails=(props)=>{
    const {data} =props;
    if(data){
      let headers=[];
      let bodys=[];
      if(data.info.length>0){
        data.info.map((item,index)=>{
          headers[index]=<div className="text-left">
              <div>
                <span className="drawer-accordion-body-block-subtitle">Name: </span>
                <span className="drawer-accordion-body-block-value">{item.name}</span>
              </div>  
              <div>
                <span className="drawer-accordion-body-block-subtitle">Number of videos: </span>
                <span className="drawer-accordion-body-block-value">{item.content.length}</span>
              </div>  
            </div>;
        });
      }
      return (<div className="drawer-100 drawer-overflow height-147">
        <div className="drawer-carousel">
            <DrawContentEpochs data={data} />
            <Accordion2 headers={headers} body={bodys} noreInfo={false} />
        </div>
        </div>)
    }
    else
      return <div></div>
    }
  
  const DrawContentHighlightedDetails=(props)=>{
    const {data} =props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
    }
    return (<div className="drawer-100 drawer-overflow height-147">
    <div className="drawer-carousel">
        <DrawContentEpochs data={data} />
        <div className="drawer-100">
          <HtmlBodyHighlighted data={data.info} size={size}/>
        </div>
      </div>
    </div>);
  }

  const DrawContentSportRoomDetails=(props)=>{
    const {data} =props;
    let size;
    if(data){
      size= getCanvasBlockSize(data.content.w,data.content.h);
      return (<div className="drawer-100 drawer-overflow height-147">
        <div className="drawer-carousel">
            <DrawContentEpochs data={data} />
            <HtmlBodySportRoom data={data.info} size={size} />
        </div>
      </div>)
    }
    else
      return <div></div>
  }

  const DrawContentCarouselDetails=(props)=>{
    const {data} =props;
    if(data){
      let headers=[];
      let bodys=[];
      let size=getCanvasBlockSize(data.content.w,data.content.h);
      if(data.info.carouselItems){
        data.info.carouselItems.map((item,index)=>{
          if(item.contentType=="staticImage"){
            headers[index]="Preview Image";
            bodys[index]=HtmlBodyStaticImage({data:item,size:size});  
          }else if(item.contentType=="room"){
            headers[index]="Sport Room";
            bodys[index]=HtmlBodySportRoom({data:item,size:size});  
          }
          else{
          headers[index]=item.name;
          bodys[index]=HtmlBodyHighlighted({data:item,size:size});
          }
        });
      }
      return (<div className="drawer-100 drawer-overflow height-147">
        <div className="drawer-carousel">
            {data.info.backgroundImage && <DrawContentBackgroundImageDetails data={data} />}
            <Accordion2 headers={headers} body={bodys} moreInfo={true} />
        </div>
      </div>)
    }
    else
      return <div></div>
  }

  // const DrawContentBackgroundImage=(props)=>{
  //   const {data,title} =props;
  //   return (
  //     <div className="drawer-content" data="backgroundImage">
  //       <DrawContentTitle title={title} subTitle="Drawer information"  type="backgroundImage"/>
  //       <DrawContentBackgroundImageDetails data={data} />
  //     </div>)
  // }
  const DrawContentApp2AppTravel=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="contentCategory">
        <DrawContentTitle title={title} subTitle="Drawer information" type="App2AppTravel" />
        <DrawContentApp2AppTravelDetails data={data}/>
      </div>)
  }
  const DrawContentCategory=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="contentCategory">
        <DrawContentTitle title={title} subTitle="Drawer information" type="category" />
        <DrawContentCategoryDetails data={data}/>
      </div>)
  }

  const DrawContentHighlightedContent=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="highlightedContent">
        <DrawContentTitle title={title} subTitle="Drawer information"  type="highlighted"/>
        {data && <DrawContentHighlightedDetails data={data} />}
      </div>)
  }

  const DrawContentStaticImage=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="staticImage">
        <DrawContentTitle title={title} subTitle="Drawer information"  type="static"/>
        <DrawContentStaticImageDetails data={data} />
      </div>)
  }

  const DrawContentBackgroundImage=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="backgroundImage">
        <DrawContentTitle title={title} subTitle="Drawer information"  type="backgroundImage"/>
        <DrawContentBackgroundImageDetails data={data} />
      </div>)
  }

  const DrawContentInteractableGraphics=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="interactableGraphics">
      <DrawContentTitle title={title} subTitle="Drawer information"  type="interactable"/>
      <DrawContentInteractableGraphicsDetails data={data} />
    </div>)
  }

  const DrawContentCalendar=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="calendar">
      <DrawContentTitle title={title} subTitle="Drawer information"  type="calendar"/>
      <DrawContentCalendarDetails data={data} />
    </div>)
  }
 
  const DrawContentCarousel=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="carousel">
        <DrawContentTitle title={title} subTitle="Drawer information" type="carousel" />
        <DrawContentCarouselDetails data={data} />
      </div>)
  }

  const DrawContentSpacesCarousel=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="spacesCarousel">
        <DrawContentTitle title={title} subTitle="Drawer information" type="spacesCarousel" />
        <DrawContentCarouselDetails data={data} />
      </div>)
  }
  const handleOnBlockSelected=(uid)=>{
    onBlockSelected(uid);
  }
  const handleOnUpdateInfoContent=(newElem)=>{
    onUpdateInfoContent(newElem);
  }

  const DrawContentSportRoom=(props)=>{
    const {data,title} =props;
    return (
      <div className="drawer-content" data="sportRoom">
      <DrawContentTitle title={title} subTitle="Drawer information"  type="interactable"/>
      <DrawContentSportRoomDetails data={data} />
    </div>)
  }

  return (
    <>
    {/* {!containersDraw && <div>no containers found</div>} */}
    {containersDraw && 
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId='container0'  direction="horizontal">
            {(provided, snapshot) => (
                <div className={"area"} id={canvasMode+"Area"}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                >
                   {containersDraw && containersDraw.map((container,index)=>{
                      return (
                        <Draggable key={"drag-"+container.UID} draggableId={"drag-"+container.UID} index={index}>
                            {(provided, snapshot) => (  
                              <div id={canvasMode+"-container-"+index} className="container" data-containeruid={container.UID} ref={provided.innerRef} {...provided.draggableProps}>
                                {<CanvasContainerComponent 
                                    index={index} 
                                    mode={mode} 
                                    canvasMode={canvasMode}
                                    maxItems={containersDraw.length} 
                                    container={container} 
                                    infoContent={infoContent}
                                    dateSelected={dateSelected}
                                    blockSelected={blockSelected}
                                    dragParams={provided.dragHandleProps}
                                    onUpdateContainer={handleOnUpdateContainer} 
                                    onDeleteContainer={handleOnDeleteContainer} 
                                    onNewContainer={handleOnNewContainer} 
                                    onInfoClicked={handleInfoClicked} 
                                    onBlockSelected={handleOnBlockSelected}
                                    onUpdateInfoContent={handleOnUpdateInfoContent}
                                    />}
                              </div>
                            )}
                        </Draggable>
                      )
                  })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
    }
       <Drawer
          open={isOpen}
          onClose={handlerCloseDrawer}
          direction='right'
          className='canvas-drawer'
          size={"640px"}
          >
            {drawerInfoType=="App2AppTravel" && <DrawContentApp2AppTravel title="App2App travel" data={drawerInfo}/>}
            {drawerInfoType=="contentCategory" && <DrawContentCategory title="Content category" data={drawerInfo}/>}
            {drawerInfoType=="staticImage" && <DrawContentStaticImage title="Static image" data={drawerInfo} />}
            {drawerInfoType=="backgroundImage" && <DrawContentBackgroundImage title="Background image" data={drawerInfo} />}
            {drawerInfoType=="calendar" && <DrawContentCalendar title="Calendar" data={drawerInfo} />}
            {drawerInfoType=="interactableGraphics" && <DrawContentInteractableGraphics title="Interactable graphics" data={drawerInfo} />}
            {drawerInfoType=="highlightedContent" && <DrawContentHighlightedContent title={"Highlighted content"} data={drawerInfo} />}
            {drawerInfoType=="carousel" && <DrawContentCarousel title="Carousel" data={drawerInfo} />}
            {drawerInfoType=="backgroundImage" && <DrawContentBackgroundImage title="Background image" data={drawerInfo} />}
            {drawerInfoType=="sportRoom" && drawerInfo && <DrawContentSportRoom title="Room" data={drawerInfo}/>}
            {drawerInfoType=="spacesCarousel" && <DrawContentSpacesCarousel title="Spaces Carousel" data={drawerInfo} />}
            {drawerInfoType=="externalContent" && <DrawContentHighlightedContent title={"External content"} data={drawerInfo} />}

        </Drawer>
    </>
  );
};

CanvasContainers.propTypes = {
    /**
     * Array of containers information
     */
     containers: PropTypes.array,
     mode:PropTypes.string,
     blockSelected:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
     /**
      * Function to propagate to parent to send to server the object
      */
     onUpdate:PropTypes.func
};

CanvasContainers.defaultProps = {
    containers:[],
    blockSelected:null
};
export default CanvasContainers;
